<template>
  <b-table-simple
    responsive
    class="table-daily-houses scrollable-area scrollable-area-x"
    sticky-header
  >
    <b-thead>
      <b-tr>
        <b-th style="background-color: transparent !important"></b-th>
        <b-th style="background-color: transparent !important"></b-th>
        <b-th
          style="vertical-align: middle"
          v-for="house in Object.keys(houses)"
          :key="house"
        >
          {{ houses[house].house_name }}
        </b-th>
        <b-th> - </b-th>
        <b-th>
          <div class="header-balance">
            <div class="header-daily-balance">Saldo Diário</div>
            <div class="header-munshrooms">
              <span v-for="type in productTypes" :key="type">
                {{ type }}
              </span>
            </div>
          </div>
        </b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr>
        <b-td class="date-row">
          <b-row class="mt-4">
            <b-col class="day" cols="12"> {{ dateFilter.day }} </b-col>
            <b-col class="month" cols="12">
              {{ formatMonth(dateFilter.month) }}
            </b-col>
          </b-row>
        </b-td>
        <b-td>
          <div style="margin-bottom: 8px">
            <span style="color: transparent"> - </span>
          </div>
          <div class="rows-period-table mb-2">
            <span> Manhã </span>
          </div>
          <div class="rows-period-table">
            <span> Tarde </span>
          </div>
        </b-td>
        <b-td
          v-for="(house, index) in Object.keys(houses)"
          :key="house"
          :class="{ 'border-right': index !== Object.keys(houses).length - 1 }"
        >
          <div class="row-quantity-daily-houses mr-1 ml-1">
            <div>
              <span>Bandeja</span>
            </div>
            <div>
              <span>Quilos</span>
            </div>
          </div>
          <div class="mt-2 mb-2 rows-period-table row-quantity-daily-houses">
            <div
              :contenteditable="isEditable() ? 'true' : 'false'"
              @input="handleQuantityEdit($event, house, 'manhã', 'plate')"
              @keydown="handleKeyDown"
              @blur="handleQuantityEdit($event, house, 'manhã', 'plate')"
            >
              {{ getHarvestData(house, 'manhã', 'plate') }}
            </div>
            <div
              :contenteditable="isEditable() ? 'true' : 'false'"
              @input="handleQuantityEdit($event, house, 'manhã')"
              @keydown="handleKeyDown"
              @blur="handleQuantityEdit($event, house, 'manhã')"
            >
              {{ getHarvestData(house, 'manhã', 'kg') }}
            </div>
          </div>
          <div class="rows-period-table row-quantity-daily-houses">
            <div
              :contenteditable="isEditable() ? 'true' : 'false'"
              @input="handleQuantityEdit($event, house, 'tarde', 'plate')"
              @keydown="handleKeyDown"
              @blur="handleQuantityEdit($event, house, 'tarde', 'plate')"
            >
              {{ getHarvestData(house, 'tarde', 'plate') }}
            </div>
            <div
              :contenteditable="isEditable() ? 'true' : 'false'"
              @input="handleQuantityEdit($event, house, 'tarde')"
              @keydown="handleKeyDown"
              @blur="handleQuantityEdit($event, house, 'tarde')"
            >
              {{ getHarvestData(house, 'tarde', 'kg') }}
            </div>
          </div>
        </b-td>
        <b-td></b-td>
        <b-td>
          <div class="row-quantity-daily-balance mr-1 ml-1 mb-3">
            <div
              class="row-daily-balance"
              v-for="type in productTypes"
              :key="type"
            >
              <div>
                <span>Bandeja</span>
              </div>
              <div>
                <span>Quilos</span>
              </div>
            </div>
          </div>
          <div class="row-quantity-daily-balance">
            <div
              class="row-daily-balance"
              v-for="type in productTypes"
              :key="type"
            >
              <div>
                <span>{{ calculateDailyQuantity(type, 'bdj') }}</span>
              </div>
              <div>
                <span>{{ calculateDailyQuantity(type, 'kg') }}</span>
              </div>
            </div>
          </div>
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import { EditHarvest, AddHarvest } from '../../services/Harvest';
import { Houses } from '../../services/House';
import showError from '../../utils/showError';

export default {
  data() {
    return {
      houses: [],
      dateFilter: {
        day: '',
        month: '',
        year: '',
      },
      todayDate: '',
      selectedDate: '',
      productTypes: [],
      dailyQuantitiesKG: 0,
      dailyQuantitiesBDJ: 0,
      monthMap: {
        Janeiro: '01',
        Fevereiro: '02',
        Março: '03',
        Abril: '04',
        Maio: '05',
        Junho: '06',
        Julho: '07',
        Agosto: '08',
        Setembro: '09',
        Outubro: '10',
        Novembro: '11',
        Dezembro: '12',
      },
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    harvests: {
      type: Array,
      required: true,
    },
  },
  watch: {
    data: {
      handler(newData) {
        this.dateFilter = newData;
        this.getDates();
        this.adicionarColheitasIniciais();
        this.productTypes = [];
        this.harvests.forEach((harvest) => {
          if (harvest.harvest_date === this.selectedDate) {
            if (!this.productTypes.includes(harvest.product_type)) {
              this.productTypes.push(harvest.product_type);
            }
          }
        });
      },
      deep: true,
    },
  },

  methods: {
    isEditable() {
      if (this.selectedDate === this.todayDate) {
        return true;
      }
      return false;
    },

    async getDates() {
      this.selectedDate = `${this.dateFilter.year}-${
        this.monthMap[this.dateFilter.month]
      }-${
        this.dateFilter.day < 10
          ? `0${this.dateFilter.day}`
          : this.dateFilter.day
      }`;

      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();

      this.todayDate = `${year}-${month < 10 ? `0${month}` : month}-${
        day < 10 ? `0${day}` : day
      }`;
    },
    async adicionarColheitasIniciais() {
      this.houses.forEach((house) => {
        // Verifique se já existe uma colheita para esta casa nesta data
        const existingHarvest = this.harvests.find((h) => {
          return (
            h.houses.id === house.id &&
            h.harvest_date === this.selectedDate &&
            h.shift === 'manhã'
          );
        });

        if (this.todayDate === this.selectedDate) {
          // Se não existir, crie uma nova colheita com valores zerados
          if (!existingHarvest && house.compound) {
            const newHarvest = {
              harvest_date: this.selectedDate,
              shift: 'manhã',
              house_id: house.id,
              harvest_quantity_kg: 0,
              harvest_quantity_plate: 0,
              product_type: house.compound.product.type,
            };
            AddHarvest(newHarvest)
              .then(() => {
                this.$emit('updateHarvests');
              })
              .catch(showError);
          }
        }

        // Repita o mesmo processo para o turno da tarde
        const existingHarvestTarde = this.harvests.find((h) => {
          return (
            h.houses.id === house.id &&
            h.harvest_date === this.selectedDate &&
            h.shift === 'tarde'
          );
        });

        if (this.todayDate === this.selectedDate) {
          if (!existingHarvestTarde && house.compound) {
            const newHarvestTarde = {
              harvest_date: this.selectedDate,
              shift: 'tarde',
              house_id: house.id,
              harvest_quantity_kg: 0,
              harvest_quantity_plate: 0,
              product_type: house.compound.product.type,
            };
            AddHarvest(newHarvestTarde)
              .then(() => {
                this.$emit('updateHarvests');
              })
              .catch(showError);
          }
        }
      });
    },
    formatMonth(month) {
      return month.substring(0, 3).toUpperCase();
    },

    calculateDailyQuantity(type, unit) {
      let dailyQuantity = 0;

      const harvests = this.harvests.filter((h) => {
        return h.harvest_date === this.selectedDate;
      });

      harvests.forEach((harvest) => {
        const productType = harvest.product_type;

        if (productType === type) {
          if (unit === 'bdj') {
            dailyQuantity += harvest.harvest_quantity_plate;
          } else {
            dailyQuantity += harvest.harvest_quantity_kg;
          }
        }
      });

      return dailyQuantity;
    },
    handleKeyDown(event) {
      if (event.keyCode === 13 || event.key === 'Enter') {
        event.preventDefault();
        event.target.blur();
      }
    },
    getHarvestData(houseId, shift, type) {
      const id = parseFloat(houseId) + 1;

      const harvest = this.harvests.find((h) => {
        return (
          h.houses.id === id &&
          h.shift === shift &&
          h.harvest_date === this.selectedDate
        );
      });

      if (harvest) {
        if (type === 'plate') {
          return harvest.harvest_quantity_plate;
        }
        return harvest.harvest_quantity_kg;
      }
      return '';
    },

    handleQuantityEdit(event, houseId, shift, type) {
      const newValue = event.target.textContent.trim();
      if (event.type === 'blur' && parseFloat(newValue) >= 0) {
        const id = parseFloat(houseId) + 1;

        const existingHarvest = this.harvests.find((h) => {
          return (
            h.houses.id === id &&
            h.shift === shift &&
            this.selectedDate === h.harvest_date
          );
        });

        if (existingHarvest) {
          if (type === 'plate') {
            existingHarvest.harvest_quantity_plate = parseFloat(newValue);
          } else {
            existingHarvest.harvest_quantity_kg = parseFloat(newValue);
          }

          const data = {
            shift: existingHarvest.shift,
            harvest_quantity_kg: existingHarvest.harvest_quantity_kg,
            harvest_quantity_plate: existingHarvest.harvest_quantity_plate,
            product_type: existingHarvest.product_type,
          };

          EditHarvest(existingHarvest.id, data)
            .then(() => {
              this.$toasted.global.defaultSuccess();
              this.$emit('updateHarvests');
            })
            .catch(showError);
        } else {
          showError('Casa sem composto associado');
          const { target } = event;
          target.textContent = '';
        }
      }
    },
  },
  async created() {
    await Houses().then((response) => {
      this.houses = response.data;
    });

    await this.getDates();

    await this.adicionarColheitasIniciais();

    await this.harvests.forEach((harvest) => {
      if (harvest.harvest_date === this.selectedDate) {
        if (!this.productTypes.includes(harvest.product_type)) {
          this.productTypes.push(harvest.product_type);
        }
      }
    });
  },
};
</script>

<style>
.table-daily-houses {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  text-align: center;
}

.table-daily-houses th {
  background-color: #7a7a7a !important;
  color: white !important;
  font-weight: 600;
  font-size: 18px;
  border: none;
}

.table-daily-houses th:nth-last-child(2) {
  background-color: transparent !important;
  color: transparent !important;
}

.table-daily-houses th:nth-last-child(1) {
  padding: 0 !important;
  background-color: transparent !important;
}

.table-daily-houses tr {
  font-weight: 500 !important;
  font-size: 13px !important;
  color: #000000 !important;
}

.table-daily-houses td {
  padding: 0.75rem 0 !important;
}

.header-balance {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header-daily-balance {
  background: #ffffff;
  border-radius: 7px 7px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 700;
  font-size: 16.2832px;
  line-height: 20px;
  letter-spacing: 0.135em;
  color: #d65600;

  height: 100%;
  width: 100%;
}

.header-munshrooms {
  display: flex;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  padding: 0.2rem;
  background: #f4f4f4;
  font-size: 18px;
  color: #000000;
}

.row-quantity-daily-balance {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 5px;
}

.row-daily-balance {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.row-quantity-daily-balance:last-child {
  background: rgba(179, 179, 179, 0.46);
}

.date-row {
  vertical-align: middle !important;
}

.date-row .day {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.095em;
}

.date-row .month {
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
}

.row-quantity-daily-houses {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 6.2px;
}

.rows-period-table {
  background-color: #efefef;
}

.border-right {
  border-right: 1px dashed #b3b3b3 !important;
}
</style>
